import Home from '@/views/Home.vue';
import ErrorsManager from '@/views/ErrorsManager.vue';
import Sonar from '@/views/Sonar.vue';
import SchemaRegistry from '@/views/SchemaRegistry.vue';
import Authentication from '@/views/Authentication.vue';
import Releases from '@/views/Releases';
import Storage from '@/views/Storage';
import ProxyApi from '@/views/ProxyApi.vue';
import AtlasAdmin from '@/views/AtlasAdmin.vue';
import ReleasesNotes from '@/views/ReleasesNotes/ReleasesNotesHome.vue';
import Referentials from '@/views/Referentials/Referentials.vue';
import EventHubs from '@/views/EventHubs/EventHubsHome.vue';
import Metrics from '@/views/Metrics/Metrics.vue';
import Consumers from '@/views/Consumers/ConsumersHome.vue';

import {DIVISIONS, ROLES} from '@/utils/authentication';

export const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      label: 'Search',
      icon: 'mdi-home',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.ALL]
      }
    }
  },
  {
    path: '/referentials',
    name: 'Referentials',
    component: Referentials,
    meta: {
      label: 'Referentials',
      icon: 'mdi-application-braces-outline',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.ALL]
      }
    }
  },
  {
    path: '/storage',
    name: 'Storage',
    component: Storage,
    meta: {
      label: 'Storage',
      icon: 'mdi-folder-key',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.TROIS_DIV]
      }
    }
  },
  {
    path: '/proxy-api',
    name: 'ProxyApi',
    component: ProxyApi,
    meta: {
      label: 'Proxy API',
      icon: 'mdi-robot',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.ALL]
      }
    }
  },
  {
    path: '/atlas-admin',
    name: 'AtlasAdmin',
    component: AtlasAdmin,
    meta: {
      label: 'Atlas Admin',
      icon: 'mdi-leaf',
      authorization: {
        role: ROLES.ADMIN,
        divisions: [DIVISIONS.TROIS_DIV]
      }
    }
  },
  {
    path: '/release-notes',
    name: 'ReleasesNotes',
    component: ReleasesNotes,
    meta: {
      label: 'Release Note',
      icon: 'mdi-notebook-heart',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.TROIS_DIV]
      }
    }
  },
  {
    path: '/event-hubs',
    name: 'Event Hubs',
    component: EventHubs,
    meta: {
      label: 'Event Hubs',
      icon: 'mdi-notebook-heart',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.ALL]
      }
    }
  },
  {
    path: '/consumers',
    name: 'Consumers',
    component: Consumers,
    meta: {
      label: 'Consumers',
      icon: 'mdi-notebook-heart',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.ALL]
      }
    }
  },
  {
    path: '/errors-manager',
    name: 'ErrorPage',
    component: ErrorsManager,
    meta: {
      label: 'Error',
      icon: 'mdi-image-broken',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.ALL]
      }
    }
  },
  {
    path: '/sonar',
    name: 'Sonar',
    component: Sonar,
    meta: {
      label: 'Sonar',
      icon: 'mdi-check-outline',
     authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.TROIS_DIV]
      }
    }
  },
  {
    path: '/metrics',
    name: 'Metrics',
    component: Metrics,
    meta: {
      label: 'Metrics',
      icon: 'mdi-vector-polyline',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.TROIS_DIV]
      }
    }
  },
  {
    path: '/registry',
    name: 'SchemaRegistry',
    component: SchemaRegistry,
    meta: {
      label: 'Schema',
      icon: 'mdi-file-document',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.FSH, DIVISIONS.FBP, DIVISIONS.WFJ]
      }
    }
  },
  {
    path: '/releases',
    name: 'Releases',
    component: Releases,
    meta: {
      label: 'Releases',
      icon: 'mdi-numeric',
      authorization: {
        role: ROLES.VIEWER,
        divisions: [DIVISIONS.ALL]
      }
    }
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import('@/components/ErrorPages/Forbidden')
  },
  {
    path: '/unregistered',
    name: 'UnknownUser',
    component: () => import('@/components/ErrorPages/UnknownUser')
  },
  {
    path: '/auth',
    name: 'Authentication',
    component: Authentication
  }
];
